module.exports = __webpack_public_path__ + "img/v4.4da373b2.png";